import React, { useState, useEffect } from 'react'
import ErrorState from 'Admin/components/ErrorState';
import LoadingState from 'Admin/components/LoadingState';
import MsgAlert from 'Admin/components/MsgAlert';
import { Dialog, DialogContent } from '@mui/material';
import { GenGet, GenPost } from 'state/api';
import VerVenda from '../Vendas/VerVenda';

function VerCaixa({id}) {
    const [msg, setMsg] = useState(null);
    const [error, seError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [caixa, setCaixa] = useState({})
    const [vendaPointer, setVendaPointer] = useState(null);
    const [detalheVendaModalOpen, setDetalheVendaModalOpen] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const total = caixa && caixa.vendas ? caixa.vendas.map((item) => parseInt(item.total)).reduce((total, item) => total + item, 0).toFixed(2) : 0

    const handleDetalhes = (id) => {
        setVendaPointer(id);
        setDetalheVendaModalOpen(true);
    }

    const handleExcluirVenda = async (id) => {
        if (!window.confirm('Tem certeza que deseja excluir esta venda?')) {
            return;
        }

        try {
            const response = await GenPost(`/deletevenda/${id}`);
            setMsg(response.message || 'Venda excluída com sucesso');
            setTimeout(() => setMsg(null), 3000);
            setRefresh(true);
        } catch (err) {
            setMsg(err.message || 'Erro ao excluir venda');
            setTimeout(() => setMsg(null), 3000);
        }
    }

    const fetchData = async (endpoint, setter) => {
      try {
        const response = await GenGet(endpoint);
        console.log(response)
        setter(response)
  
      } catch (err) {
        seError(true);      
      }
    };
  
    useEffect(() => {
      Promise.all([
          fetchData(`/caixa/${id}`, setCaixa),
      ]).then(() => setLoading(false)); 
  
    }, []);

    useEffect(() => {
        if (refresh) {
            setLoading(true);
            Promise.all([
                fetchData(`/caixa/${id}`, setCaixa),
            ]).then(() => {
                setLoading(false);
                setRefresh(false);
            }); 
        }
    }, [refresh, id]);

    if (loading) {
        return (
          <LoadingState />
        )
      }
    
      if (error) {
        return (
          <ErrorState />
        )
      }

    return (
        <div className="flex flex-col relative">
            {caixa && (
                <div className="flex flex-col overflow-y-hidden h-[85vh]">
                    <h2 className="text-[12pt] font-semibold p-0 m-0">Informações do Caixa</h2>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Código: {caixa.id}</p>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Data de Abertura: {caixa.data_abertura}</p>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Valor de Abertura: {caixa.valor_abertura}</p>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Valor de Fechamento: {caixa.valor_abertura}</p>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Responsável pela Abertura: {caixa.responsavel_abertura}</p>
                    <p className="text-[10pt] font-semibold p-0 ml-2 my-0">Responsável pelo Fechamento: {caixa.responsavel_fechamento}</p>
                    <br/>
                    
                    <h3 className="text-[12pt] font-semibold p-0 m-0">Vendas</h3>
                    <br/>

                    <ul className="flex gap-1 flex-col overflow-y-scroll h-full">
                        {caixa.vendas.map(venda => (
                            <li className="flex gap-2 p-2 border rounded-md" key={venda.id}>
                                <p  className="text-[10pt] h-full font-semibold p-0 my-0">ID Venda: {venda.id}</p>
                                <p className="text-[10pt] h-full font-semibold p-0 my-0"> - Cliente ID: {venda.cliente_id}</p>
                                <p className="text-[10pt] h-full font-semibold p-0 my-0"> - Total: {venda.total}</p>
                                <p className="text-[10pt] h-full font-semibold p-0 my-0"> - Modo de Pagamento: {venda.modo_pagamento}</p>
                                <div className="flex gap-2 justify-end flex-grow">
                                    <button className="bg-blue-400 flex justify-center items-center align-middle hover:bg-blue-500 px-2 rounded-sm text-[9pt] text-slate-50" onClick={() => handleDetalhes(venda.id)}>Detalhes</button>
                                    <button className="bg-red-400 flex justify-center items-center align-middle hover:bg-red-500 px-2 rounded-sm text-[9pt] text-slate-50" onClick={() => handleExcluirVenda(venda.id)}>Excluir</button>
                                </div>
                            </li>
                        ))}
                    </ul>

                    <p className="text-[12pt] font-semibold p-0 ml-2 mt-2">Total: R$ {total}</p>

                </div>
            )}
            <Dialog 
                open={detalheVendaModalOpen && vendaPointer} 
                onClose={() => setDetalheVendaModalOpen(false)} 
                PaperProps={{
                    style: {
                        width: '70vw',
                        height: '80vh',
                        maxWidth: 'none', 
                        maxHeight: 'none',
                        }
                    }}
                >
                <DialogContent>
                    <VerVenda id={vendaPointer} />
                </DialogContent>
            </Dialog>

            <MsgAlert alert={msg} />

        </div>
    );
}

export default VerCaixa